import CryptoJS from 'crypto-js';

export default function encryptHandler() {
  const encryptFile = (val) => {
    const sectionId = String(val);

    let encryptReference = CryptoJS.AES.encrypt(
      sectionId,
      process.env.VUE_APP_ENCRYPT_SECRET_KEY
    ).toString();

    return encryptReference;
  };
  return {
    encryptFile
  };
}
